import React from 'react'
import Img from 'gatsby-image'
import BaseBlockContent from '@sanity/block-content-to-react'

const GalleryItem = ({ item, handleClick }) => {
  return (
    <div className="gallery-item" onClick={handleClick}>
      <div className="gallery-item-content-wrapper">
        <div className="gallery-item-content">
          <Img fluid={item.image.asset.fluid} alt="" />
        </div>
      </div>
      <div className="gallery-item-caption">
        <BaseBlockContent
          blocks={item._rawCaption}
          projectId={process.env.GATSBY_SANITY_PROJECT_ID}
          dataset={process.env.GATSBY_SANITY_DATASET}
        />
      </div>
    </div>
  )
}

export default GalleryItem
